import { css } from '@emotion/react';
import { colors, spacing, typography } from '#themes/stena-recycling';

const triggerBase = ({ error }: { error?: boolean }) => css`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing.xxsmall};
  height: ${spacing.mediumHigh};
  padding: 0 ${spacing.xmsmall};
  margin: 0;
  outline: 0;
  border: 1px solid ${error ? colors.alerts.error : colors.monochrome.grey40};
  border-radius: 4px;
  font-family: inherit;
  font-size: ${typography.other.inputValue.fontSize};
  line-height: ${typography.other.inputValue.lineHeight};
  color: ${colors.base.black};
  background-color: canvas;
  min-width: 12rem;
`;

export const styles = {
  Trigger: (props: { error?: boolean }) => css`
    ${triggerBase(props)};
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;

    &[data-placeholder] {
      color: ${colors.monochrome.grey50};
    }

    @media (hover: hover) {
      &:hover {
        border-color: ${props.error ? colors.alerts.error : colors.primary.grey};
      }
    }

    &[data-popup-open] {
      border-color: ${props.error ? colors.alerts.error : colors.primary.grey};
    }

    &:focus-visible {
      outline: 0 !important;
      border-color: ${props.error ? colors.alerts.error : colors.primary.grey};
    }

    &[data-disabled] {
      background-color: ${colors.monochrome.grey10};
      color: ${colors.monochrome.grey60};
      border-color: ${colors.monochrome.grey40};
      cursor: not-allowed;
    }
  `,
  EditableSingleValue: (props: { error?: boolean }) => css`
    ${triggerBase(props)};
    padding-right: ${spacing.xxsmall};

    &:focus-within {
      border-color: ${props.error ? colors.alerts.error : colors.primary.grey};
    }

    &:has([data-popup-open]) {
      border-color: ${props.error ? colors.alerts.error : colors.primary.grey};
    }

    &[data-disabled] {
      background-color: ${colors.monochrome.grey10};
      color: ${colors.monochrome.grey60};
      border-color: ${colors.monochrome.grey40};
    }
  `,
  EditableInput: css`
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    height: 100%;
    padding: 0;
    border: 0;
    outline: 0;
    color: inherit;
    background: transparent;
    font: inherit;

    &::placeholder {
      color: ${colors.monochrome.grey50};
    }

    &:disabled {
      cursor: not-allowed;
    }
  `,
  EditableSingleValueButton: css`
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin: 0;
    border: 0;
    color: inherit;
    background: transparent;
    cursor: pointer;

    &:focus-visible {
      outline: 2px solid ${colors.primary.grey};
      outline-offset: 2px;
      border-radius: 2px;
    }

    &:disabled {
      color: ${colors.monochrome.grey60};
      cursor: not-allowed;
    }
  `,
  SelectIcon: css`
    display: flex;
    margin-left: auto;
    color: ${colors.base.black};
    transform: rotate(0deg);

    [data-popup-open] & {
      transform: rotate(180deg);
    }
  `,
  DefaultValue: () => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: ${spacing.xxsmall};
    width: 100%;
    min-width: 0;
  `,
  DefaultValueText: css`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
  DefaultValueCount: css`
    flex-shrink: 0;
  `,
};
